const Tile = ({ title, value, valueType }) => {
  const checkType = () => {
    if (valueType === "currency") {
      return <p>${new Intl.NumberFormat("es-CL").format(value)}</p>;
    }
    return <p>{value}</p>;
  };
  return (
    <div className="tile-container">
      <h4>{title}</h4>
      {checkType()}
    </div>
  );
};

export default Tile;
